import ToggleModal from './ToggleModal';
import { withI18n } from 'react-i18next';

export default withI18n()(ToggleModal);
